import { AccountContext } from '../context/accountContext'
import { useContext } from 'react'


// Returns the context and makes sure we are using it within the correct scope 
export const useAccountContext = () => {
    const context = useContext(AccountContext)

    if (!context) {
        throw Error('useAccountContext must be used inside an AccountContextProvider')
    }

    return context;
}